import userType from "../../actions/user/userType";

const initialState = {
  isLogin: false,
  userToken: "",
  userRole: "",
  userDetail: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case userType.SET_LOGIN_USER:
      return {
        ...state,
        isLogin: true,
        userToken: action.payload.token,
        userRefreshToken: action.payload?.refresh,
        userRole: action.payload.role,
        userDetail: [action.payload.details],
      };
    case userType.SET_LOGOUT_USER:
      return {
        ...state,
        isLogin: false,
        userToken: "",
        userRefreshToken: "",
        userRole: "",
        userDetail: [],
      };

    case userType.SET_UPDATE_USER_DETAIL:
      return { ...state, userDetail: [action.payload] };
    case userType.SET_UPDATE_USER_IMAGE:
      return { ...state, userDetail: [] };

    default:
      return state;
  }
};

export default userReducer;
